export default __webpack_public_path__ + "static/media/EA.9bc9d2d1.svg";